(() => {
  if (window.mmProductV2Bound) return;
  window.mmProductV2Bound = true;
  let lastTrigger;
  document.addEventListener('click', event => {
    const thumb = event.target.closest('[data-pv-cover]');
    if (thumb) {
      const gallery = thumb.closest('.pv-gallery');
      const button = gallery.querySelector('.pv-cover button');
      const img = button.querySelector('img');
      img.removeAttribute('srcset');
      img.src = thumb.dataset.pvCover;
      img.alt = thumb.dataset.pvAlt;
      button.dataset.pvZoom = thumb.dataset.pvCover;
      gallery.querySelectorAll('[data-pv-cover]').forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
    }
    const zoom = event.target.closest('[data-pv-zoom]');
    const dialog = document.getElementById('pv-lightbox');
    if (zoom && dialog) {
      lastTrigger = zoom;
      const image = dialog.querySelector('img');
      image.src = zoom.dataset.pvZoom;
      image.alt = zoom.querySelector('img')?.alt || '';
      if (!dialog.open) dialog.showModal();
    }
    if (event.target.closest('[data-pv-close]') && dialog) dialog.close();
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  document.addEventListener('close', event => {
    if (event.target.id === 'pv-lightbox') lastTrigger?.focus();
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-pv-variant]')) return;
    const option = event.target.selectedOptions[0];
    const available = option.dataset.available === 'true';
    document.querySelectorAll('[data-pv-price]').forEach(el => el.textContent = option.dataset.price);
    document.querySelectorAll('[data-pv-buy]').forEach(button => {
      button.disabled = !available;
      button.textContent = available ? button.dataset.label : button.dataset.unavailable;
    });
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
  });
})();

if (!customElements.get('mm-review-carousel')) {
  customElements.define('mm-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-review-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      this.position = this.querySelector('[data-review-position]');
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.pv-review');
        if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'instant' });
      }, options);
      this.observer?.disconnect();
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap || 0);
      this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    update() {
      const cards = [...this.track.children];
      const view = this.track.getBoundingClientRect();
      const visible = cards.map((card,index) => ({ index, box: card.getBoundingClientRect() })).filter(item => item.box.left >= view.left - 4 && item.box.right <= view.right + 4);
      const first = visible.length ? visible[0].index + 1 : 1;
      const last = visible.length ? visible[visible.length - 1].index + 1 : first;
      this.position.textContent = `${first === last ? first : first + '–' + last} / ${cards.length}`;
      this.prev.disabled = this.track.scrollLeft < 4;
      this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
      this.querySelector('[data-review-controls]').hidden = this.track.scrollWidth <= this.track.clientWidth + 4;
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}
